import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
import styled, { css, keyframes } from 'styled-components';
import { variant } from 'styled-system';
import { get } from '../../styles/constant';
const spinnerAnimation = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    transform: rotate(220deg);\n  }\n  100% {\n    transform: rotate(580deg);\n  }\n"])));
const barAnimation = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0% {\n    transform: translateX(-100%);\n    left: 0;\n  }\n  100% {\n    transform: translateX(0);\n    left: 100%;\n  }\n"])));
export const spinnerAnimationStyled = css(['', ' 1s infinite;'], spinnerAnimation);
const barAnimationStyled = css(['', ' 1.2s infinite;'], barAnimation);
const spinnerIndicatorFit = variant({
  prop: 'fit',
  variants: {
    small: {
      'min-height': get('space.16'),
      'min-width': get('space.16')
    },
    medium: {
      'min-height': get('space.20'),
      'min-width': get('space.20')
    },
    large: {
      'min-height': get('space.24'),
      'min-width': get('space.24')
    }
  }
});
const spinnerSVGFit = variant({
  prop: 'fit',
  variants: {
    small: {
      height: get('space.16'),
      width: get('space.16')
    },
    medium: {
      height: get('space.20'),
      width: get('space.20')
    },
    large: {
      height: get('space.24'),
      width: get('space.24')
    }
  }
});
const barIndicatorFit = variant({
  prop: 'fit',
  variants: {
    small: {
      height: get('space.2')
    },
    medium: {
      height: get('space.4')
    },
    large: {
      height: get('space.8')
    }
  }
});
const indicatorVariants = variant({
  prop: 'variant',
  variants: {
    bar: {
      alignItems: 'flex-start'
    },
    spinner: {
      alignItems: 'center'
    }
  }
});
export const Label = styled.label(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  font-family: 'Maersk Text';\n  font-weight: 400;\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  margin-top: ", ";\n"])), get('fontSizes.14'), get('lineHeights.20'), props => props.appearance === 'default' ? get('colors.functional.grey.800') : get('colors.functional.grey.50'), props => props.orientation === 'vertical' ? "".concat(get('space.8')) : "".concat(get('space.0')));
const spinnerIndicatorStyles = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  ", ";\n  & svg {\n    ", "\n    animation: ", ";\n    position: absolute;\n    & .spinner {\n      stroke: ", ";\n      stroke-width: 12.5;\n    }\n    & .track {\n      stroke: ", ";\n      opacity: ", ";\n      stroke-width: 12.5;\n    }\n  }\n"])), spinnerIndicatorFit, spinnerSVGFit, spinnerAnimationStyled, props => props.appearance === 'default' ? '#00243d' : get('colors.functional.grey.50'), get('colors.functional.grey.200'), props => props.appearance === 'default' ? '100%' : '30%');
const barIndicatorStyles = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n  position: relative;\n  overflow: hidden;\n  margin-top: ", ";\n  border-radius: $height / 2;\n  width: 100%;\n  &:before,\n  &:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: ", ";\n    background-color: ", ";\n    opacity: 30%;\n  }\n\n  &:after {\n    right: auto;\n    width: 50%;\n    background-color: ", ";\n    opacity: 100%;\n    animation: ", ";\n  }\n"])), barIndicatorFit, get('space.8'), get('space.8'), get('colors.functional.grey.200'), props => props.appearance === 'default' ? get('colors.primary.blue.300') : get('colors.functional.grey.50'), barAnimationStyled);
const SpinnerIndicator = styled.div.attrs(_ref => {
  let {
    fit
  } = _ref;
  return {
    fit
  };
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", "\n"])), spinnerIndicatorStyles);
const BarIndicator = styled.div.attrs(_ref2 => {
  let {
    fit
  } = _ref2;
  return {
    fit
  };
})(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", "\n"])), barIndicatorStyles);
const variants = {
  indicatorVariants,
  spinnerIndicatorFit,
  barIndicatorFit
};
const styles = css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ", ";\n  column-gap: ", ";\n  background-color: ", ";\n"])), props => props.orientation === 'vertical' ? 'column' : 'row', props => props.orientation === 'vertical' ? "".concat(get('space.0')(props)) : "".concat(get('space.8')(props)), props => props.appearance === 'default' ? get('colors.functional.grey.50') : get('colors.primary.blue.900'));
const LoaderWrapper = styled.div.attrs(_ref3 => {
  let {
    children
  } = _ref3;
  return {
    children
  };
})(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), styles, variants.indicatorVariants);
const Components = {
  Label,
  SpinnerIndicator,
  BarIndicator,
  LoaderWrapper
};
export { styles, variants, spinnerIndicatorStyles, Components };